module.exports = __webpack_public_path__ + "static/img/bn.dc0686c4.png";